export default __webpack_public_path__ + "static/media/bag1.c42e5f7d.png";